import { render, staticRenderFns } from "./Devize_in_lucru_list.vue?vue&type=template&id=654ebfe2&scoped=true"
import script from "./Devize_in_lucru_list.vue?vue&type=script&lang=js"
export * from "./Devize_in_lucru_list.vue?vue&type=script&lang=js"
import style0 from "./Devize_in_lucru_list.vue?vue&type=style&index=0&id=654ebfe2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654ebfe2",
  null
  
)

export default component.exports